<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
import { genRewardNoResettleColumns, REWARD_NO_RESETTLE_DATA_SOURCE } from '../../tools'
const [name] = createNamespace('GroundAttachCompStandardForm')
export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    },
    prefix: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props) {
    const genFormItemName = (key: string) => [...props.prefix, key]
    const columns: TableColumnType[] = [
      ...genRewardNoResettleColumns(),
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 100,
        customRender({ record }) {
          return (
            <FormItem name={genFormItemName(record.key)} rules={getRequiredRule(`${record.group}-${record.type}标准`)}>
              <InputRmb v-model:value={data.value[record.key]} style='width: 100%' />
            </FormItem>
          )
        }
      }
    ]
    const data = toRef(props, 'dataSync', {})
    return () => <Table pagination={false} columns={columns} dataSource={REWARD_NO_RESETTLE_DATA_SOURCE} size='small' />
  }
})
</script>
